export default class LayerDefine {
}
LayerDefine.Root = Math.pow(2, 1);
LayerDefine.Player = Math.pow(2, 2);
LayerDefine.Item = Math.pow(2, 3);
LayerDefine.Ammo = Math.pow(2, 4);
LayerDefine.Door = Math.pow(2, 5);
LayerDefine.Enemy = Math.pow(2, 6);
